import { Element } from "@siteimprove/alfa-dom";
import { PseudoClassSelector } from "./pseudo-class.js";
const { isElement } = Element;
/**
 * {@link https://drafts.csswg.org/selectors/#only-child-pseudo}
 */
export class OnlyChild extends PseudoClassSelector {
    static of() {
        return new OnlyChild();
    }
    constructor() {
        super("only-child");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element) {
        return element.inclusiveSiblings().filter(isElement).size === 1;
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (OnlyChild) {
    OnlyChild.parse = PseudoClassSelector.parseNonFunctional("only-child", OnlyChild.of);
})(OnlyChild || (OnlyChild = {}));
//# sourceMappingURL=only-child.js.map